export const PCCCategoryIds = {
    ADMISSIONS: 'ADMISSIONS',
    CDV: 'CDV',
    DIARY: 'DIARY',
    SCAN_STATION: 'SCAN_STATION',
    APPT_HISTORY: 'APPT_HISTORY',
    // PEER_REVIEWS: 'PEER_REVIEWS'
}

export const PCCCategories = [
    {
        id: PCCCategoryIds.ADMISSIONS,
        name: 'Admissions'
    },
    {
        id: PCCCategoryIds.CDV,
        name: 'CDV'
    },
    {
        id: PCCCategoryIds.DIARY,
        name: 'Diary'
    },
    {
        id: PCCCategoryIds.SCAN_STATION,
        name: 'Scan Station'
    },
    {
        id: PCCCategoryIds.APPT_HISTORY,
        name: 'Appointment History'
    },
    // {
    //     id: PCCCategoryIds.PEER_REVIEWS,
    //     name: 'Peer Reviews'
    // }
]
